import { useState } from 'react'
import { supabase } from '../lib/supabase'
import { saveCaissierSession } from '../lib/caissierSession'
import { getDeviceId } from '../lib/api'

export default function AccesCaissier({ onSuccess }) {
  const [code, setCode] = useState('')
  const [pin, setPin] = useState('')
  const [loading, setLoading] = useState(false)
  const [erreur, setErreur] = useState('')
  const [bloque, setBloque] = useState(false)

  async function handleLogin(e) {
    e.preventDefault()
    if (!code.trim() || !pin.trim()) {
      setErreur('Entre le code boutique et le PIN.')
      return
    }
    setLoading(true); setErreur('')

    // Le device_id permet un blocage par appareil, pas par boutique
    const { data, error } = await supabase.rpc('verifier_pin', {
      code_boutique: code.trim().toUpperCase(),
      pin_code: pin.trim(),
      p_device_id: getDeviceId()
    })

    setLoading(false)

    if (error) {
      setErreur('Erreur de connexion. Réessayez.')
      return
    }

    const result = data?.[0]

    if (!result?.boutique_id) {
      const msg = result?.erreur || 'Code ou PIN incorrect.'
      setErreur(msg)
      if (msg.includes('bloqué') || msg.includes('bloque') || msg.includes('Trop de tentatives')) {
        setBloque(true)
        setTimeout(() => { setBloque(false); setErreur('') }, 15 * 60 * 1000)
      }
      return
    }

    saveCaissierSession({
      boutiqueId: result.boutique_id,
      boutiqueNom: result.boutique_nom
    })
    onSuccess({
      boutiqueId: result.boutique_id,
      boutiqueNom: result.boutique_nom
    })
  }

  const estBloquant = bloque || erreur.includes('bloqu') || erreur.includes('Trop de tentatives')

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--cream)', padding: '1.5rem'
    }}>
      <div style={{
        background: 'white', borderRadius: 'var(--radius-xl)', padding: '2rem',
        width: '100%', maxWidth: 360, boxShadow: 'var(--shadow-lg)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ fontFamily: 'Fraunces, serif', fontSize: 32, fontWeight: 700, marginBottom: 4 }}>
            Stock<span style={{ color: 'var(--sage)', fontStyle: 'italic' }}>O</span>
          </div>
          <div style={{ fontSize: 13, color: 'var(--muted)' }}>Accès Caissier</div>
        </div>

        {bloque && (
          <div style={{
            background: 'var(--rose-pale)', border: '1.5px solid #DFA0A0',
            borderRadius: 'var(--radius-md)', padding: '12px 14px',
            marginBottom: '1.5rem', textAlign: 'center'
          }}>
            <div style={{ fontSize: 28, marginBottom: 6 }}>🔒</div>
            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--rose)', marginBottom: 4 }}>
              Cet appareil est bloqué
            </div>
            <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.6 }}>
              3 tentatives incorrectes.<br />Réessayez dans 15 minutes.
            </div>
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div className="field">
            <label style={{ fontSize: 12 }}>Code boutique (4 caractères)</label>
            <input
              type="text" placeholder="Ex: ABCD" value={code}
              onChange={e => { setCode(e.target.value.toUpperCase()); setErreur('') }}
              maxLength={4} disabled={estBloquant}
              style={{ textTransform: 'uppercase', letterSpacing: 4, textAlign: 'center', fontSize: 20 }}
            />
          </div>

          <div className="field">
            <label style={{ fontSize: 12 }}>Code PIN (4 chiffres)</label>
            <input
              type="password" placeholder="••••" value={pin}
              onChange={e => { setPin(e.target.value); setErreur('') }}
              maxLength={4} inputMode="numeric" disabled={estBloquant}
              style={{ letterSpacing: 8, textAlign: 'center', fontSize: 24 }}
            />
          </div>

          {erreur && !bloque && (
            <div style={{
              background: 'var(--amber-pale)', border: '1px solid #E8C080',
              borderRadius: 'var(--radius-md)', padding: '10px 12px',
              fontSize: 12, color: '#633806', lineHeight: 1.6,
              marginBottom: '1rem', textAlign: 'center'
            }}>
              ⚠️ {erreur}
            </div>
          )}

          <button
            type="submit" className="btn-primary"
            disabled={loading || estBloquant}
            style={{ width: '100%', marginTop: '0.5rem' }}
          >
            {loading ? 'Connexion...' : estBloquant ? '🔒 Bloqué 15 min' : 'Se connecter →'}
          </button>
        </form>
      </div>
    </div>
  )
}
